(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("salte.auth", [], factory);
	else if(typeof exports === 'object')
		exports["salte.auth"] = factory();
	else
		root["salte.auth"] = factory();
})(window, function() {
return 